import { BASEURL } from "../../config";

async function loginUser(payload: any) {
  try {
    const url = `${BASEURL}auth/login`;
    const headers = {
      "Content-Type": "application/json",
    };
    const body = JSON.stringify(payload);

    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: body,
    });

    return await response.json();
  } catch (error) {
    console.error("Fetch failed:", error);
  }
}
async function resetPassword(payload: any) {
  try {
    const {token, password}=payload
    
    const url = `${BASEURL}adminAuth/reset-password${token?'?token='+token:''}`;
    const headers = {
      "Content-Type": "application/json",
    };
    const body = JSON.stringify({password});

    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: body,
    });

    return await response.json();
  } catch (error) {
    console.error("Fetch failed:", error);
  }
}

export { loginUser, resetPassword };
